export default "__VITE_ASSET__39b0c757__"